import React, { PureComponent } from 'react'
import { Platform } from 'react-native'

import ActualSlider from 'react-native-slider'

export default class VertiicalSlider extends PureComponent {
  render () {
    let { value, onValueChange, minimumValue, maximumValue, minimumTrackTintColor, maximumTrackTintColor, thumbTintColor, thumbTouchSize, step, disabled } = this.props

    let inverted = true
    let changeFun = onValueChange
    if (Platform.OS === 'web') {
      [minimumTrackTintColor, maximumTrackTintColor] = [maximumTrackTintColor, minimumTrackTintColor]
      inverted = false
      changeFun = val => onValueChange(maximumValue - val + minimumValue)
      value = maximumValue - value + minimumValue
    }

    return (
      <ActualSlider
        value={value}
        onValueChange={changeFun}
        minimumValue={minimumValue}
        maximumValue={maximumValue}
        minimumTrackTintColor={minimumTrackTintColor}
        maximumTrackTintColor={maximumTrackTintColor}
        thumbTintColor={thumbTintColor}
        thumbTouchSize={thumbTouchSize}
        step={step}
        orientation='vertical'
        inverted={inverted}
        disabled={disabled}
      />
    )
  }
}
